// extracted by mini-css-extract-plugin
export var borderTop = "_p-3";
export var linkIcon = "_p-5";
export var linkIconSm = "_p-6";
export var linkOutCard = "_p-7 _p-4";
export var linkRow = "_p-2";
export var pageContainer = "_p-1";
export var providerIcon = "_p-8";
export var roundedBorder = "_p-4";
export var settingsContent = "_p-0";